import React from 'react';
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

export const OrderDetailsDialog = props => {
  const { open, setOpen, order } = props;

  return (
    <Dialog
      sx={{ zIndex: 9999 }}
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="add-new-house-dialog"
      fullWidth
    >
      <DialogTitle id="add-new-house-dialog">Szczegółowe dane uczestnika {order.participant_name}</DialogTitle>
      <DialogContent>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Nr zamówienia</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.identifier}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Nr umowy</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.agreement_number}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Data urodzenia</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.participant_birth_date}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Płeć</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.participant_gender == 'boy' ? 'Chłopiec' : 'Dziewczynka'}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Impreza</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.event__name}</Typography>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Przedział wiekowy</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.event__age_range__name}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Zachowanie</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.participant_behavior}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Inne uwagi</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.participant_other_comments}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Wspólne Zakwaterowanie - Uwagi</Typography>
          <Typography
            sx={{ flex: '1 1 70%' }}
          > {order.shared_accommodation_info}</Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
